import React, { ReactNode } from 'react'
import { RiArrowDownSFill } from 'react-icons/ri'

interface Props {
	header: React.ReactNode
	children: React.ReactNode
	handleClick: () => void
	expand?: boolean
	buttonAction?: ReactNode
}

/**
 * Displays `header` and a button to expand or collapse `children`. If `buttonAction` is provided, it will be displayed next to the expand/collapse button.
 * This is a controlled components, meaning that the parent component is responsible for managing the `expand` state via the props `handleClick` and `expand`.
 */
export default function Collapsible({
	expand,
	header,
	children,
	handleClick,
	buttonAction,
}: Props): JSX.Element {
	return (
		<div className="p-2 rounded-lg bg-brand-deep-blue">
			<div className="flex justify-between">
				{header}
				<div className="flex items-center text-right">
					{buttonAction && <div className="mx-2">{buttonAction}</div>}
					<button className="border-l-2 h-full pl-2 " onClick={handleClick}>
						<RiArrowDownSFill
							className={`scale-150 ${expand ? 'rotate-180' : ''}`}
						/>
					</button>
				</div>
			</div>
			{expand && (
				<>
					<hr className="mt-2" />
					{children}
				</>
			)}
		</div>
	)
}
